// extracted by mini-css-extract-plugin
module.exports = {"steps":"UserSteps_steps__2MTyO","sidebar":"UserSteps_sidebar__1suU5"};